import React, { Component } from "react";
import { Link } from "react-router-dom";
import PDF from "../images/media/okas-mannual.pdf";
import "../css/supportRemoteRequest.css";
import { connect } from 'react-redux';
import Loader from '../components/loader';
import { is_allowed } from "../utils";


class SupportRemoteRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            okasBoxData: {
                project_building: {},
                subscription_data: {
                    status: ""
                }
            },
            // okasBoxData: null,
            expiredStatus: '',
            technician_id: '',
            client_id: '',
            time_required: '',
            ticketHistory: [],
            status: ["hold", "closed", "open"], // Default status options
            selectedStatus: "", // Default selected status
            reply: "", // Store reply input,
            is_sharing_okas: false,
            loading: false,
            user_info: {},
            isLoadingData: false
        };
    }

    // Fetch support ticket data
    fetchData = (url, token) => {
        this.setState({ isLoadingData: true })
        // fetching ticket info

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
                'X-CSRFToken': localStorage.getItem('csrftoken')
            },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then(data => {
                // console.log(data)

                this.setState({ okasBoxData: data, selectedStatus: data.ticket_status });
                this.setState({ isLoadingData: false })
                //fetching ticket history
                fetch(`/we/support-ticket-history/${data.ticket_id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                        'X-CSRFToken': localStorage.getItem('csrftoken')
                    },
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Failed to fetch data');
                        }
                        return response.json();
                    })
                    .then(data => {

                        this.setState({ ticketHistory: data });
                    })
                    // console.log(this.props.redux.globalVar.userTypeStyle)
                    .catch(error => console.error('Error fetching data:', error));
            })
            .catch(error => { console.error('Error fetching data:', error); this.setState({ isLoadingData: false }) });



    };

    generateRemoteAccessToken = () => {
        const { technician_id, client_id, time_required } = this.state;


        // Extract project_id (building_id) from the state data
        const { building_id: projectId, remote_access_port } = this.state.okasBoxData.project_building;

        // Check if a token already exists for this project_id in localStorage
        const existingToken = localStorage.getItem(`remoteToken_${projectId}`);
        const existingTokenExpiresAt = localStorage.getItem(`remoteTokenExpiresAt_${projectId}`);

        if (existingToken && existingTokenExpiresAt) {
            // Parse the expiration time and compare it with the current time
            const expiresAt = new Date(existingTokenExpiresAt);
            const currentTime = new Date();

            // If the token has not expired, show an alert
            if (currentTime < expiresAt) {
                // console.log(remote_access_port)
                this.validateRemoteAccessToken(existingToken, projectId, remote_access_port)

            }
        } else {
            this.generateToken(projectId, remote_access_port)
        }

    };

    generateToken() {
        // Extract project_id (building_id) from the state data
        const { building_id: projectId, remote_access_port } = this.state.okasBoxData.project_building;
        const TokenValue = 'Token ' + localStorage.getItem("auth"); // Assuming token is stored in localStorage
        // If no existing token or the token is expired, proceed with token generation
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken=')).split('=')[1];
        // const {building_id: projectId, project_building} = this.state.okasBoxData.project_building;

        const payload = {
            ticket_id: Number(this.state.okasBoxData.ticket_id),
            client_id: projectId,
            time_required: Number(this.state.okasBoxData.duration) || 48,  // Use the dynamic value from the state/
        };
        fetch('/we/generate-remote-access-token/', {
            method: 'POST',
            headers: {
                'Authorization': TokenValue,
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {


                if (data.token && data.expires_at) {
                    // Save the generated token and expiration time in localStorage
                    // localStorage.setItem(`remoteToken_${projectId}`, data.token);
                    // localStorage.setItem(`remoteTokenExpiresAt_${projectId}`, data.expires_at);
                    // console.log('Remote access token generated and saved:', data);

                    // alert('redirecting to access');

                    window.location.href = `/support2/remote-access2/${projectId}?port=${remote_access_port}&project-id=${projectId}`
                    // window.location.href = this.props.redux.globalVar.userTypeStyle === '3'
                    //     ? `/support2/remote-access2/${projectId}?port=${remote_access_port}&token=${data.token}`
                    //     : `/support/remote-access/${projectId}?port=${remote_access_port}&token=${data.token}`;
                    window.location.href =
                        (this.props.redux.globalVar.userTypeStyle === "3" || (this.props.redux.globalVar.userTypeStyle === "4" && this.state.checkuserApidata.source === 'Distributor'))
                            ? `/support2/remote-access2/${projectId}?port=${remote_access_port}&token=${data.token}`
                            : `/support/remote-access/${projectId}?port=${remote_access_port}&token=${data.token}`;


                } else {
                    if (window.confirm("Remote Access Expired, Do you want to take again ?")) {
                        window.location.href = `/remote-access?project=${this.state.okasBoxData.project_building.building_id}`; // Change to your desired URL
                    } else {
                        // console.log("User canceled the action.");
                    }

                    // console.error('Failed to generate tokensd:', data);
                }
            })
            .catch(error => {

                console.error('Error generating remote access token:', error);
            })
    }

    validateRemoteAccessToken(token, projectId, remote_access_port) {
        const TokenValue = 'Token ' + localStorage.getItem("auth"); // Assuming token is stored in localStorage
        // If no existing token or the token is expired, proceed with token generation
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken=')).split('=')[1];
        const payload = {
            token
        };
        fetch('/we/validate-remote-access-token/', {
            method: 'POST',
            headers: {
                'Authorization': TokenValue,
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {

                if (data.status === "valid") {

                    // window.location.href = `/support2/remote-access2/${projectId}?port=${remote_access_port}`
                    // window.location.href = this.props.redux.globalVar.userTypeStyle === '3'
                    //     ? `/support2/remote-access2/${projectId}?port=${projectId}`
                    //     : `/support/remote-access/${projectId}?port=${projectId}`;
                    window.location.href =
                        (this.props.redux.globalVar.userTypeStyle === "3" || (this.props.redux.globalVar.userTypeStyle === "4" && this.state.checkuserApidata.source === 'Distributor'))
                            ? `/support2/remote-access2/${projectId}?port=${projectId}`
                            : `/support/remote-access/${projectId}?port=${projectId}`;


                } else {
                    alert("remote access time expired. request access again")
                    localStorage.removeItem(`remoteToken_${projectId}`);
                    localStorage.removeItem(`remoteTokenExpiresAt_${projectId}`);
                }
            })
            .catch(error => {
                console.error('Error generating remote access token:', error);
            });
    }

    componentDidMount() {

        this.checkuserApi();


        // Extract ticket_id from URL
        const ticketId = window.location.pathname.split('/')[2];

        if (isNaN(ticketId)) {
            console.error('Invalid ticket_id:', ticketId);
            return;
        }

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        this.fetchData(`/we/supportticket-detail/${ticketId}`, TokenValue);
    }

    handleStatusChange = (e) => {
        this.setState({ selectedStatus: e.target.value });
    };

    handleReplyChange = (e) => {
        this.setState({ reply: e.target.value });
    };

    handleSubmit = () => {
        // Set the loading state
        this.setState({ isLoading: true, successMessage: "" });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const csrfTokenCookie = document.cookie
            .split('; ')
            .find(row => row.startsWith('csrftoken='));

        const csrfToken = csrfTokenCookie ? csrfTokenCookie.split('=')[1] : null;

        fetch(`/we/support-ticket-history/${this.state.okasBoxData.ticket_id}`, {
            method: 'POST',
            headers: {
                'Authorization': TokenValue,
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify({
                status: this.state.selectedStatus,
                message: this.state.reply,
                user: "support@okas.ai", // Replace with dynamic value if needed
            }),
        })
            .then(response => response.json())
            .then(data => {
                //  console.log("Server Response:", data); // Log the response for debugging

                // Since the response contains a message, check if the message is "ticket history created"
                if (data.message === "ticket history created") {
                    this.setState({
                        isLoading: false,
                        successMessage: "ticket history created",

                    });
                    alert("Status Updated")
                    window.location.reload();
                } else {
                    // console.error('Unexpected response:', data);
                    this.setState({ isLoading: false });
                    alert(data.message || 'Error while sending the reply.');
                }
            })
            .catch(error => {
                // console.error('Error while replying:', error);
                this.setState({ isLoading: false });
                alert('An error occurred. Please try again.');
            });
    };




    shareToOkas = () => {
        this.setState({ is_sharing_okas: true })

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        // If no existing token or the token is expired, proceed with token generation
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken=')).split('=')[1];
        fetch(`/we/assign-ticket-to-okas/${this.state.okasBoxData.ticket_id}/`, {
            method: 'POST',
            headers: {
                'Authorization': TokenValue,
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.status == 200) {
                    // Save the generated token and expiration time in localStorage

                    alert(`Assigned To ${(this.props.redux.globalVar.userTypeStyle == "1" || this.props.redux.globalVar.userTypeStyle == "2") ? 'Distributor' : 'OKAS'}`);
                } else {
                    alert("Error while assiging")
                    // console.error('Error while assiging:', data);
                }
            })
            .catch(error => {
                alert("Error while assiging")
                // console.error('Error while assigning:', error);
            }).finally(() => { this.setState({ is_sharing_okas: false }); window.location.reload() });
    }

    getTimeDifference(timestamp) {
        const givenDate = new Date(timestamp); // Parse the given timestamp
        const currentDate = new Date(); // Get the current date and time

        const diffInMilliseconds = currentDate - givenDate; // Calculate the difference in milliseconds

        // Convert the difference to seconds, minutes, hours, and days
        const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        // Determine how to display the difference
        if (diffInMinutes < 60) {
            return `${diffInMinutes} minute(s)`;
        } else if (diffInHours < 24) {
            return `${diffInHours} hour(s)`;
        } else {
            return `${diffInDays} day(s)`;
        }
    }




    async handleWriteWithAi() {
        // Set loading to true when the request starts
        this.setState({ loading: true });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const csrfToken = document.cookie.split('; ').find(row => row.startsWith('csrftoken=')).split('=')[1];

        try {
            // Make the API call
            let response = await fetch("/we/write-with-ai/", {
                method: 'POST',
                headers: {
                    'Authorization': TokenValue,
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify({ text: this.state.reply }),
            });

            let result = await response.json();

            if (result.corrected_text) {
                // Update the reply state with corrected text if available
                this.setState({ reply: result.corrected_text });
            } else {
                alert("No text provided!");
            }
        } catch (error) {
            //console.log(error);
            alert("Service unavailable");
        } finally {
            // Set loading to false once the request is completed (either success or failure)
            this.setState({ loading: false });
        }
    }


    checkuserApi = () => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/userCheckApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(checkuserApidata => {
                // console.log(checkuserApidata)
                // checkuserApidata = {
                //     "first_name": "OKAS Training",
                //     "User_Type": "3",
                //     "user_name": "training@vyom.ai",
                //     "status": "200"
                // }
                this.setState({
                    user_info: checkuserApidata
                })
            })
    }

    render() {
        const { okasBoxData, isLoadingData } = this.state;

        console.log(okasBoxData);

        if (!okasBoxData) {
            return <div>Loading...</div>;
        }

        return (
            isLoadingData === true ? <Loader /> :
                <div className="container dashboardContainer supportBox" >
                    <div className="support-container">

                        <div className="row">
                            <div className='welcomeMessage'>
                                <h2>OKAS Support Dashboard</h2> <p style={{ fontSize: '14px' }}>Manage & Track Tickets Manage your ticket effectively, take immediate action on pending issues and ensure smooth operations
                                </p>
                            </div>
                        </div>


                        <div className="main-content">
                            <div className="ticket" style={{ width: '65%' }}>
                                <h2 style={{ marginBottom: '4%' }}>{`${okasBoxData.custom_ticket_id}`}: Support Request</h2>

                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="textline" style={{ maxWidth: "37rem", }}>
                                        <h4 style={{ fontWeight: "bold", marginTop: "0px" }}>TICKET DETAILS</h4>
                                        <p style={{ wordBreak: 'break-word' }}>
                                            {okasBoxData.issue_description}
                                        </p>
                                    </div>
                                    <div className="projctflex" >
                                        <div className="project-details">
                                            <span>
                                                <h4 style={{ fontWeight: "bold" }}>PROJECT DETAILS</h4>
                                                <p style={{ color: '#707070' }}><strong style={{ color: "#707070" }}>Project Name:</strong> {okasBoxData.project_building.building_name}</p>
                                                <p style={{ color: '#707070' }}><strong style={{ color: "#707070" }}>Location:</strong> {okasBoxData.project_building.address}</p>
                                                <p style={{ color: '#707070' }}>
                                                    <strong style={{ color: "#707070" }}>Subscription Status:</strong>
                                                    {okasBoxData.subscription_data === null ? "inactive" : " " + okasBoxData.subscription_data.status.charAt(0).toUpperCase() + okasBoxData.subscription_data.status.slice(1).toLowerCase()}
                                                </p>
                                                <p style={{ color: '#707070' }}><strong style={{ color: "#707070" }}>Remote Access:</strong> {okasBoxData.remote_access ? "Enabled" : "Disabled"}</p>
                                            </span>
                                        </div>
                                    </div>
                                </div>


                                {(
                                    (this.props.redux.globalVar.userTypeStyle == '3'
                                        ? this.state.okasBoxData.created_by === this.state.user_info.user_name
                                            ? true
                                            : this.state.okasBoxData.assign_to_distributor === this.state.user_info.user_name
                                        : this.state.okasBoxData.assign_to_distributor === null
                                    ) &&
                                    is_allowed(
                                        this.props.redux.permissions.permissions?.[0],
                                        localStorage.getItem("name"),
                                        "support",
                                        "share ticket"
                                    )
                                ) && (
                                        <>
                                            <div style={{ marginTop: '2%' }}>
                                                {okasBoxData.ticket_status !== 'closed' && (okasBoxData.remote_access ? (
                                                    <button
                                                        className="access-button"
                                                        onClick={this.generateToken.bind(this)}
                                                        style={{
                                                            marginTop: '2%',
                                                            padding: '10px 20px',
                                                            borderRadius: '50px',
                                                            backgroundColor: this.state.expiredStatus === 'expired' ? '#D3D3D3' : '#F5AE56',
                                                            cursor: this.state.expiredStatus === 'expired' ? 'not-allowed' : 'pointer',
                                                        }}
                                                        disabled={this.state.expiredStatus === 'expired'}
                                                    >
                                                        <div className="buttontext" style={{
                                                            fontWeight: '500',
                                                            borderRadius: "50px",
                                                            border: "100"
                                                        }}>
                                                            Access Design Studio Remotely
                                                        </div>
                                                    </button>
                                                ) : (
                                                    <Link to="/remote-access">
                                                        <button
                                                            className="access-button"
                                                            style={{
                                                                marginTop: '2%',
                                                                padding: '10px 20px',
                                                                borderRadius: '50px',
                                                                backgroundColor: '#F5AE56',
                                                                color: '#FFFFFF',
                                                                border: "revert-layer",
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            <div className="buttontext" style={{ fontWeight: '500' }}>Request Remote Access</div>
                                                        </button>
                                                    </Link>
                                                ))}
                                            </div>

                                            <div className="reply-section">
                                                <label htmlFor="reply">Reply</label>

                                                <div style={{ position: "relative" }}>
                                                    <textarea
                                                        id="reply"
                                                        placeholder=""
                                                        value={this.state.reply}
                                                        onChange={this.handleReplyChange}
                                                        maxLength={300}
                                                        style={{
                                                            width: '100%',
                                                            marginBottom: '10px',
                                                            height: '120px',
                                                            borderRadius: '10px',
                                                            resize: 'none',
                                                            outline: 'none',
                                                            backgroundColor: '#ebe3e3',
                                                            padding: '10px 100px 10px 10px',
                                                        }}
                                                    />

                                                    <button
                                                        onClick={this.handleWriteWithAi.bind(this)}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '0px',
                                                            top: '0px',
                                                            outline: 'none',
                                                            border: 'none',
                                                            background: 'transparent',
                                                            borderRadius: '5px',
                                                            padding: '8px 16px',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {this.state.loading ? (
                                                            <div className="loader"></div>
                                                        ) : (
                                                            'write with AI'
                                                        )}
                                                    </button>

                                                    <style>
                                                        {`
          .loader {
            border: 4px solid #f3f3f3;
            border-top: 4px solid #f39522;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            animation: spin 2s linear infinite;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
                                                    </style>
                                                </div>

                                                <div className="statusselect" style={{ marginBottom: '10px' }}>
                                                    <label htmlFor="status" style={{ marginBottom: '5px' }}>Status</label>
                                                    <select
                                                        id="status"
                                                        value={this.state.selectedStatus}
                                                        onChange={this.handleStatusChange}
                                                        style={{
                                                            width: '100%',
                                                            padding: '8px',
                                                            borderRadius: '5px',
                                                            border: '1px solid #ccc',
                                                            outline: 'none',
                                                            backgroundColor: '#ebe3e3'
                                                        }}
                                                    >
                                                        {this.state.status.map((status, index) => (
                                                            <option key={index} value={status}>
                                                                {status.charAt(0).toUpperCase() + status.slice(1)}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                                    <button
                                                        style={{
                                                            fontSize: "17px",
                                                            fontWeight: "700",
                                                            padding: "10px 20px",
                                                            backgroundColor: this.state.isLoading ? "#ccc" : "",
                                                            cursor: this.state.isLoading ? "not-allowed" : "pointer",
                                                        }}
                                                        className="submit-button"
                                                        onClick={!this.state.isLoading ? this.handleSubmit : null}
                                                        disabled={this.state.isLoading}
                                                    >
                                                        {this.state.isLoading ? "Submitting..." : "Submit"}
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}



                                {
                                    this.state.ticketHistory.length > 0 &&
                                    <div style={{ margin: "20px 0", fontFamily: "Arial, sans-serif" }}>
                                        <h2 style={{ textAlign: "center", color: "#333", marginBottom: "20px" }}>
                                            Ticket History
                                        </h2>
                                        <table style={{ width: "100%", borderCollapse: "collapse", boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)" }}>
                                            <thead>
                                                <tr style={{ backgroundColor: "#F28C19", color: "#fff" }}>
                                                    <th style={{ padding: "10px", textAlign: "center", fontSize: "16px", backgroundColor: "#F28C19" }}>Status</th>
                                                    <th style={{ padding: "10px", textAlign: "center", fontSize: "16px", backgroundColor: "#F28C19" }}>Message</th>
                                                    <th style={{ padding: "10px", textAlign: "center", fontSize: "16px", backgroundColor: "#F28C19" }}>User</th>
                                                    <th style={{ padding: "10px", textAlign: "center", fontSize: "16px", backgroundColor: "#F28C19" }}>Created At</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.ticketHistory.map((history, index) => (
                                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
                                                        <td style={{ padding: "8px", textAlign: "center", border: "1px solid #ddd" }}>
                                                            {history.status}
                                                        </td>
                                                        <td style={{ padding: "8px", textAlign: "center", border: "1px solid #ddd" }}>
                                                            {history.message}
                                                        </td>
                                                        <td style={{ padding: "8px", textAlign: "center", border: "1px solid #ddd" }}>
                                                            {history.user}
                                                        </td>
                                                        <td style={{ padding: "8px", textAlign: "center", border: "1px solid #ddd" }}>
                                                            {new Date(history.created_at).toLocaleString()}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                }

                            </div>
                            <div className="box-flex">
                                <div className="status-section">
                                    <h3 style={{ fontSize: '17px', color: '#707070' }}>Status: {okasBoxData.ticket_status}</h3>
                                    <p style={{
                                        marginTop: '10%',
                                        display: 'flex',
                                        alignItems: 'center',

                                    }}>
                                        <i className="fa fa-clock-o" style={{ marginRight: "8px", fontSize: '21px' }}></i>
                                        {this.getTimeDifference(okasBoxData.ticket_created_date)} Old Request
                                    </p>
                                    <ul>
                                        {/* <li style={{ marginTop: '10%' }}>
                                        <i className="fa fa-download" style={{ marginRight: "8px", fontSize: '21px' }}></i>
                                        <a href="#" style={{ textDecoration: 'none', color: '#707070' }}>Download Log Files</a>
                                    </li>
                                    <li style={{ marginTop: '10%' }}>
                                        <i className="fa fa-download" style={{ marginRight: "8px", fontSize: '21px' }}></i>
                                        <a style={{ textDecoration: 'none', color: '#707070', width: '100%' }} href="#">Download Diagnostic Report</a>
                                    </li> */}
                                        {
                                            okasBoxData.status_report && <li style={{ marginTop: '10%' }}>
                                                <i className="fa fa-download" style={{ marginRight: "8px", fontSize: '21px' }}></i>
                                                <a style={{ textDecoration: 'none', color: '#707070', width: '100%' }} target="_blank" href={okasBoxData.status_report}>Download Status Report</a>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                <div className="okas-section">
                                    <div className="manual-links">
                                        <div className="link-item">
                                            <i style={{ fontSize: '21px' }} className="fa fa-download"></i>
                                            <a
                                                href={PDF}
                                                style={{ textDecoration: 'none', color: '#707070' }}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                OKAS Manual
                                            </a>
                                        </div>

                                        {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "support", "share ticket") &&
                                            <div className="link-item">
                                                <i style={{ fontSize: '21px' }} className="fa fa-share"></i>
                                                {
                                                    (this.props.redux.globalVar.userTypeStyle == "1" || this.props.redux.globalVar.userTypeStyle == "2")
                                                        ? okasBoxData.assign_to_distributor ? <span style={{ backgroundColor: 'transparent', border: 'none', textAlign: 'left', color: '#707070' }}>Assigned To Distributor</span> : <button style={{ backgroundColor: 'transparent', border: 'none', textAlign: 'left', color: '#707070' }} onClick={this.shareToOkas}>{this.state.is_sharing_okas === true ? "Sharing..." : `Share This Ticket to Distributor`}</button>
                                                        : okasBoxData.is_assigned_to_okas ? <span style={{ backgroundColor: 'transparent', border: 'none', textAlign: 'left', color: '#707070' }}>Assigned To OKAS</span> : <button style={{ backgroundColor: 'transparent', border: 'none', textAlign: 'left', color: '#707070' }} onClick={this.shareToOkas}>{this.state.is_sharing_okas === true ? "Sharing..." : `Share This Ticket to OKAS Support`}</button>
                                                }

                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};

export default connect(mapStateToProps)(SupportRemoteRequest);

